import { Box, Typography, Divider } from '@mui/material';
import { useTranslation } from '@scorenco/core';

import { T_KEYS } from '@/translations';

import { MemberCard } from './_internal/MemberCard';

export const PlayersWidget = ({ members }) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ width: '100%', marginBottom: '1.5rem', padding: '0 5%' }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {t(T_KEYS.TEAMS_PLAYERS_STAFF)}
      </Typography>
      <Box
        sx={{
          mt: 1,
          mb: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        {!members?.filter((member) => member.is_staff).length && (
          <>
            <Typography variant="body1" component="p" sx={{ mt: 2, mb: 2 }}>
              {t(T_KEYS.TEAMS_PLAYERS_STAFF_NOBODY)} <span role="img">😮</span>
            </Typography>
          </>
        )}
        {members
          ?.filter((member) => member.is_staff)
          .map((staff, index) => (
            <>
              <MemberCard
                member={staff}
                publicName={staff.public_name}
                userRole={staff.role}
                userId={staff.member_id}
                pictureUrl={staff.photo}
                key={index}
              />
              <Divider />
            </>
          ))}
      </Box>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {t(T_KEYS.TEAMS_PLAYERS_PLAYERS)}
      </Typography>
      <Box
        sx={{
          mt: 1,
          mb: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        {!members?.filter((member) => !member.is_staff).length && (
          <>
            <Typography variant="body1" component="p" sx={{ mt: 2, mb: 2 }}>
              {t(T_KEYS.TEAMS_PLAYERS_PLAYERS_NOBODY)}{' '}
              <span role="img">😮</span>
            </Typography>
          </>
        )}
        {members
          ?.filter((member) => !member.is_staff)
          .map((player, index) => (
            <>
              <MemberCard
                member={player}
                publicName={player.public_name}
                userRole={player.role}
                userNumber={player.number}
                pictureUrl={player.photo}
                key={index}
              />
              <Divider />
            </>
          ))}
      </Box>
    </Box>
  );
};
